/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  stateSchema?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  hasState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  hasTokenUsage?: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedConversationalAgentDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset {
  return PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    stateSchema: json['state_schema'] == null ? undefined : json['state_schema'],
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'] == null ? undefined : json['has_state'],
    hasTokenUsage: json['has_token_usage'] == null ? undefined : json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    state_schema: value['stateSchema'],
    evaluate_state: value['evaluateState'],
    has_state: value['hasState'],
    has_token_usage: value['hasTokenUsage'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
  };
}
